<template>
  <div class="file-box2">

    <el-upload
      style="position:absolute;top: 0;left: 0;width: 100%;height: 100%;"
      :action="domain"
      :data="QiniuData"
      :accept="accept"
      :on-error="uploadError"
      :on-progress="uploadVideoProcess"
      :on-success="uploadSuccess"
      :before-upload="beforeAvatarUpload"
      :show-file-list="false"
      :file-list="fileList">
      <el-button type="primary">申请</el-button>
    </el-upload>
  </div>
</template>

<script>
  import {genUpToken} from '../tools/CryptoJS'
  export default {
    name: "upFile",
    data(){
      return {
        QiniuData: {
          fname: '', //  文件名
          key: "", //文件名字处理
          token: "" //七牛云token
        },
        domain: "https://upload-z1.qiniup.com/", // 七牛云的上传地址（华南区）
        qiniuaddr: "http://gyhfile.shzzfw.com", // 七牛云的图片外链地址 你的七牛云里配置有
        uploadPicUrl: "", //提交到后台图片地址
        fileList: [],
        nowTime: '',
        fileExtension: '',
        loading: null,
      }
    },
    props:{
      imgTitle:{
        type:String
      },
      accept:{
        type:String
      }
    },
    created() {
      this.nowTime = this.getDate();
      var token;
      var policy = {};
      var bucketName = 'gong-yi-hui';//你的七牛桶名称
      var AK = '_MhT6BWLiDGy2755HTwoxzNH747ecCtlqldVq3p3'; //你的七牛AK
      var SK = '15juIkGIozY13PvocO4o5lckBFb-OzqFrSVAAM7z';//你的七牛SK
      var deadline = Math.round(new Date().getTime() / 1000) + 3600;
      policy.scope = bucketName;
      policy.deadline = deadline;
      token = genUpToken(AK, SK, policy);
      this.QiniuData.token = token;
    },
    methods:{
      //  上传前判断
      beforeAvatarUpload(file) {
        if(this.accept === 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.wordprocessingml.template'){
          var fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
          if(fileExtension!== 'doc'&&fileExtension!== 'docx'&&fileExtension!== 'dot' ){
            this.$message.error('请上传Word文件')
            return false
          }
        }
        if(file.size>500*1024*1024){
          this.$message.error('请上传小于500MB的视频')
          return false
        }
        //这里的key给加上了时间戳，目的是为了防止上传冲突
        this.QiniuData.fname = file.name;
        this.QiniuData.key = `${this.nowTime}${file.name}`;
        this.loading = this.$loading({
          lock: true,
          text: '上传中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      //  上传中
      uploadVideoProcess(event, file, fileList) {
        console.log(event)
        console.log(fileList)
        this.loading.text = '已上传'+file.percentage.toFixed(0) + '%'
      },
        //  上传成功
      uploadSuccess(response, file, fileList) {
        console.log(file);
        console.log(fileList);
        this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
        this.loading.close();
        // this.$message.success('上传成功')
        this.$emit('setImg',{
          title:this.imgTitle,
          url:this.uploadPicUrl
        })
      },
      //  上传失败
      uploadError(err, file, fileList) {
        console.log(err)
        console.log(file)
        console.log(fileList)
        this.loading.close();
        this.$message({
          message: "上传出错，请重试！",
          type: "error",
          center: true
        });
      },
      //以下是时间戳函数
      getDate() {
        var myDate = new Date();
        //获取当前年
        var year = myDate.getFullYear();
        //获取当前月
        var month = myDate.getMonth() + 1;
        //获取当前日
        var date = myDate.getDate();
        var h = myDate.getHours(); //获取当前小时数(0-23)
        var m = myDate.getMinutes(); //获取当前分钟数(0-59)
        var s = myDate.getSeconds();
        //获取当前时间
        var now = year + this.conver(month) + this.conver(date) + this.conver(h) + this.conver(m) + this.conver(s) + "_";
        return now;
      },
      conver(s) {
        return s < 10 ? '0' + s : s;
      },
    }
  }
</script>

<style scoped lang="scss">
  .file-box2{
    display: block;
    width: 100%;
    height: 60px!important;
    line-height: 40px!important;
    position: relative!important;
    .el-upload{
      width: 100%;
    }
    .el-button{
      display: block;
      width: 150px;
      height: 40px;
      line-height: 40px;
      margin: 10px auto;
      padding: 0;
    }
  }
</style>
